<header class="header-2">
  <div class="branding">
    <span class="title">{{ 'Trassierungseditor' | mrTranslate }}</span>
  </div>
  <div class="header-actions">
    <a href="javascript://" class="nav-link nav-icon">
      <cds-icon shape="times" (click)="close()"></cds-icon>
    </a>
  </div>
</header>

<div class="overlay-inner-wrapper">
  <div id="measurementWrapper">
    <form clrForm class="clr-form" style="width: 100%">
      <div class="clr-row" style="margin-left: 12px">
        <div class="clr-col-2">
          {{ 'Trassierungselement' | mrTranslate }}
        </div>
        <div class="clr-col-2">
          <div class="clr-select-wrapper">
            <select
              class="clr-select"
              #sel
              [(ngModel)]="selectedtyp"
              [ngModelOptions]="{ standalone: true }"
              (change)="selecteTypChanged(sel.value)">
              @for (item of typen; track item) {
                <option [ngValue]="item['Id']">
                  {{ item['Bezeichnung'] | mrTranslate }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
      @if (selectedtyp) {
        <div class="clr-row" style="margin-top: 10px; margin-left: 12px">
          <div class="btn-group btn-primary btn-icon">
            <button class="btn btn-success" (click)="newitem()">
              <cds-icon shape="file" [title]="'neu' | mrTranslate" />
            </button>
            <button class="btn btn-danger" [disabled]="selid == 0" (click)="deletItem()">
              <cds-icon shape="times" [title]="'löschen' | mrTranslate" />
            </button>
          </div>
        </div>
        <div class="clr-row">
          <div class="clr-col-12">
            <div class="limit-height">
              @if (selecteddata?.rows?.length) {
                <clr-datagrid
                  class="datagrid-compact"
                  [clrDgRowSelection]="true"
                  [clrDgSelectionType]="'single'"
                  [clrDgSelected]="[selecteditem]"
                  (clrDgSelectedChange)="selecteditem = $event[0]; selectionItemChanged($event[0])">
                  @for (column of selecteddata.columns; track column) {
                    <clr-dg-column [clrDgField]="column.id">
                      <ng-container
                        *clrDgHideableColumn="{
                          hidden:
                            column.id | hideIDColumns: ['KSTEDTID', 'kstedtid', 'schhmax', 'bildbase64', 'Profil'],
                        }">
                        {{ column.id | mrTranslate | titlecase }}
                      </ng-container>
                    </clr-dg-column>
                  }
                  <clr-dg-row *clrDgItems="let row of selecteddata.rows" [clrDgItem]="row">
                    @for (cell of selecteddata.columns; track cell) {
                      <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                    }
                  </clr-dg-row>
                  <clr-dg-footer>{{ selecteddata.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                  <ng-template [(clrIfDetail)]="detailState" let-detail>
                    <clr-dg-detail>
                      <clr-dg-detail-body>
                        <form clrForm class="clr-form" clrLayout="horizontal">
                          <div class="clr-row" style="margin-top: 10px; margin-left: 12px">
                            <div class="clr-col-3">
                              {{ 'von' | mrUnitText }}
                            </div>
                            <div class="clr-col-1">
                              <input
                                type="number"
                                id="basic"
                                #bez
                                class="clr-input"
                                value="{{ detail['Startposition'] }}"
                                #von />
                            </div>
                          </div>
                          <div class="clr-row" style="margin-top: 10px; margin-left: 12px">
                            <div class="clr-col-3">
                              {{ 'bis' | mrUnitText }}
                            </div>
                            <div class="clr-col-1">
                              <input
                                type="number"
                                id="bis"
                                class="clr-input"
                                value="{{ detail['Endposition'] }}"
                                #bis />
                            </div>
                          </div>
                          <div class="clr-row" style="margin-top: 10px; margin-left: 12px">
                            <div class="clr-col-3">
                              {{ 'Anfangswert' | mrTranslate }}
                            </div>
                            <div class="clr-col-1">
                              <input
                                type="number"
                                id="wert1"
                                class="clr-input"
                                value="{{ detail['Anfangswert'] }}"
                                #wert1 />
                            </div>
                          </div>
                          <div class="clr-row" style="margin-top: 10px; margin-left: 12px">
                            <div class="clr-col-3">
                              {{ 'Endwert' | mrTranslate }}
                            </div>
                            <div class="clr-col-1">
                              <input
                                type="number"
                                id="wert2"
                                class="clr-input"
                                value="{{ detail['Endwert'] }}"
                                #wert2 />
                            </div>
                          </div>
                          @if (seltyp == 6) {
                            <div class="clr-row" style="margin-top: 10px; margin-left: 12px">
                              <div class="clr-col-3">
                                {{ 'Steigung in ‰' | mrTranslate }}
                              </div>
                              <div class="clr-col-1">
                                <input
                                  type="number"
                                  id="wert3"
                                  class="clr-input"
                                  value="{{ detail['Steigung'] }}"
                                  #wert3 />
                              </div>
                            </div>
                            <div class="clr-row" style="margin-top: 10px; margin-left: 12px">
                              <div class="clr-col-3">
                                {{ 'Ausrunfdungsradius' | mrTranslate }}
                              </div>
                              <div class="clr-col-1">
                                <input
                                  type="number"
                                  id="wert4"
                                  class="clr-input"
                                  value="{{ detail['Radius'] }}"
                                  #wert4 />
                              </div>
                            </div>
                          }
                          @if (seltyp != 6) {
                            <div class="clr-row" style="margin-top: 10px; margin-left: 12px">
                              <div class="clr-col-3">
                                {{ 'alternativ: Länge' | mrTranslate }}
                              </div>
                              <div class="clr-col">
                                <input type="number" id="awert" #bez class="clr-input" #awert />
                              </div>
                            </div>
                          }
                          <div class="clr-row" style="margin-top: 15px; margin-left: 10px">
                            <button
                              type="button"
                              class="btn btn-icon btn-primary"
                              [attr.aria-label]="'Speichern' | mrTranslate"
                              (click)="saveItem()">
                              <cds-icon shape="floppy" />
                            </button>
                          </div>
                        </form>
                      </clr-dg-detail-body>
                    </clr-dg-detail>
                  </ng-template>
                </clr-datagrid>
              }
            </div>
          </div>
        </div>
      }

      @if (graphdata.length > 0) {
        <div class="clr-row" style="margin-top: 10px; margin-left: 12px; width: 100%">
          <div class="clr-col-12">
            <app-plotly-plot
              [className]=""
              [data]="graphdata"
              [layout]="layout"
              [config]="graphconfig"></app-plotly-plot>
          </div>
        </div>
      }
    </form>
  </div>
</div>
